/**
 * What an environment's kind costs you if you act on the wrong one.
 *
 * One descending scale, and it has to stay one: production is unmistakable
 * because acting on it costs something real, testing warns, and everything
 * else is the floor. `info` is not below `warning` — it is orthogonal — so
 * putting development there stops the three being a scale at all.
 *
 * This is exported because four screens had each written their own copy of it
 * and three of them carried a comment saying they mirrored this one. They gave
 * development four different answers, including `positive` on the Overview,
 * which drew a development environment in the same green as a published
 * release. Derive from here; do not mirror.
 */
export function environmentTone(kind: string): "critical" | "warning" | "neutral" {
  if (kind === "production") return "critical";
  if (kind === "testing") return "warning";
  return "neutral";
}
